package ai.wagemix.logic.auth

import ai.wagemix.net.models.WMAuthFailure
import co.touchlab.kermit.Severity
import com.fsryan.foundation.util.log.FSLog
import com.fsryan.foundation.util.log.sendEventInclusive

/*
 * The analytics events of the auth presenter (planning/analytics-plan.md §5, "Account and
 * identity"). No email, name or action code ever goes on an event.
 */

/** The auth step a failure belongs to (`auth_failed.stage`). */
internal enum class WMAuthStepKind { Login, Register, Reset, VerifyEmail }

private inline fun FSLog.sendWMAuthEvent(
    eventName: String,
    throwable: Throwable? = null,
    crossinline fields: MutableMap<String, Any>.() -> Unit = {}
) {
    sendEventInclusive(throwable = throwable, severity = Severity.Info, eventName = eventName) {
        fields()
    }
}

/** The source screen is not known to the presenter, so the field is left to the site when it has one. */
internal fun FSLog.sendWMSignUpCompleted() {
    sendWMAuthEvent(eventName = "WMSignUpCompleted")
}

internal fun FSLog.sendWMLoginCompleted() {
    sendWMAuthEvent(eventName = "WMLoginCompleted")
}

internal fun FSLog.sendWMAuthFailed(stage: WMAuthStepKind, reason: WMAuthFailure, error: Throwable) {
    sendWMAuthEvent(eventName = "WMAuthFailed", throwable = error) {
        put(
            "stage",
            when (stage) {
                WMAuthStepKind.Login -> "login"
                WMAuthStepKind.Register -> "register"
                WMAuthStepKind.Reset -> "reset"
                WMAuthStepKind.VerifyEmail -> "verify_email"
            }
        )
        put("reason", reason.name)
    }
}

internal fun FSLog.sendWMPasswordResetCompleted() {
    sendWMAuthEvent(eventName = "WMPasswordResetCompleted")
}

internal fun FSLog.sendWMEmailVerified() {
    sendWMAuthEvent(eventName = "WMEmailVerified")
}
